<template>
  <div id="major-management" v-loading="loading">
    <!-- 面包导航 -->
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>招生管理</el-breadcrumb-item>
      <el-breadcrumb-item>专业组与专业管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片主体 -->
    <el-card class="box-card">
      <div class="block">
        <!-- 搜索条件区 -->
        <el-form
          :inline="true"
          :model="searchForm"
          class="search-form"
          size="mini"
        >
          <el-form-item label="学校名称">
            <el-input
              v-model="searchForm.univName"
              placeholder="请输入学校名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="专业组名称">
            <el-input
              v-model="searchForm.groupName"
              placeholder="请输入专业组名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="专业名称">
            <el-input
              v-model="searchForm.majorName"
              placeholder="请输入专业名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetSearch"
              >重置</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 功能按钮区 -->
        <el-row :gutter="20" style="margin-bottom: 15px">
          <el-col>
            <el-button
              v-hasPermission="'majorGroup:add'"
              type="primary"
              icon="el-icon-plus"
              @click="openAddGroupDialog"
              >新增专业组</el-button
            >
            <el-button
              v-hasPermission="'majorDetail:export'"
              type="warning"
              icon="el-icon-download"
              style="margin-left: 10px"
              @click="exportExcel"
              >导出数据</el-button
            >
          </el-col>
        </el-row>

        <!-- 树形表格展示 -->
        <el-table
          :data="treeData"
          border
          stripe
          style="width: 100%"
          row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          highlight-current-row
          empty-text="暂无数据，请点击【新增专业组】开始添加"
          class="tree-table"
          :row-class-name="tableRowClassName"
        >
          <!-- 展开列 -->
          <el-table-column type="expand">
            <template slot-scope="scope">
              <!-- 专业详情展开内容 -->
              <div
                v-if="scope.row.type === 'major'"
                class="major-detail-expand"
              >
                <el-descriptions column="2" border>
                  <el-descriptions-item label="班级类型">{{
                    scope.row.data.classType || "-"
                  }}</el-descriptions-item>
                  <el-descriptions-item label="合作企业">{{
                    scope.row.data.classEnterprise || "-"
                  }}</el-descriptions-item>
                  <el-descriptions-item label="招生计划总数">{{
                    scope.row.data.planNum || 0
                  }}</el-descriptions-item>
                  <el-descriptions-item label="应届普高计划数">{{
                    scope.row.data.freshAcademicNum || 0
                  }}</el-descriptions-item>
                  <el-descriptions-item label="中职往届计划数">{{
                    scope.row.data.secondaryTechGraduateNum || 0
                  }}</el-descriptions-item>
                  <el-descriptions-item label="报考总人数">{{
                    scope.row.data.totalApplicants || 0
                  }}</el-descriptions-item>
                  <el-descriptions-item label="录取率"
                    >{{
                      scope.row.data.admissionRate || 0
                    }}%</el-descriptions-item
                  >
                  <el-descriptions-item label="普高分数线">{{
                    scope.row.data.freshAcademicScoreline || "-"
                  }}</el-descriptions-item>
                  <el-descriptions-item label="中职分数线">{{
                    scope.row.data.secondaryTechScoreline || "-"
                  }}</el-descriptions-item>
                </el-descriptions>
              </div>

              <!-- 专业组展开内容 -->
              <div
                v-if="scope.row.type === 'majorGroup'"
                class="group-detail-expand"
              >
                <el-descriptions column="2" border>
                  <el-descriptions-item label="录取规则">{{
                    scope.row.data.admissionRules || "-"
                  }}</el-descriptions-item>
                  <el-descriptions-item label="考生类型">{{
                    scope.row.data.examineeType || "-"
                  }}</el-descriptions-item>
                  <el-descriptions-item label="考试形式">{{
                    scope.row.data.examForm || "-"
                  }}</el-descriptions-item>
                  <el-descriptions-item label="考试时长(分钟)">{{
                    scope.row.data.examDuration || "-"
                  }}</el-descriptions-item>
                  <el-descriptions-item label="关联考纲节点">
                    <span v-if="!scope.row.data.examSyllabus">无</span>
                    <span v-else>{{
                      formatSyllabusText(scope.row.data.examSyllabus)
                    }}</span>
                  </el-descriptions-item>
                  <!-- 试卷配置展示（修改：页面加载时不显示，引导编辑配置） -->
                  <el-descriptions-item label="试卷配置" :span="2">
                    <div class="exam-paper-preview">
                      <div class="preview-header">
                        <span>考纲节点</span>
                        <span>题量</span>
                        <span>每题分数</span>
                        <span>行总分</span>
                      </div>
                      <div class="preview-body">
                        <div
                          v-if="
                            !scope.row.examPapers ||
                            scope.row.examPapers.length === 0
                          "
                          class="no-config"
                        >
                          暂无试卷配置，请点击【编辑】按钮进行配置
                        </div>
                        <div
                          v-for="(paper, idx) in scope.row.examPapers"
                          :key="idx"
                          class="preview-row"
                        >
                          <span>{{
                            getSyllabusFullPath(paper.testCentersId)
                          }}</span>
                          <span>{{ paper.questionCount }}</span>
                          <span>{{ paper.score }}</span>
                          <span>{{
                            (paper.questionCount * paper.score).toFixed(2)
                          }}</span>
                        </div>
                      </div>
                      <div
                        class="preview-total"
                        v-if="
                          scope.row.examPapers &&
                          scope.row.examPapers.length > 0
                        "
                      >
                        试卷总分：{{
                          calculatePreviewTotal(scope.row.examPapers)
                        }}
                        分
                      </div>
                    </div>
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            </template>
          </el-table-column>

          <!-- 名称列 -->
          <el-table-column
            prop="label"
            label="名称"
            min-width="160"
            align="left"
            class-name="tree-node-name"
          >
            <template slot-scope="scope">
              <span :class="['node-indicator', scope.row.type]">
                <i
                  v-if="scope.row.type === 'university'"
                  class="el-icon-building"
                ></i>
                <i
                  v-if="scope.row.type === 'majorGroup'"
                  class="el-icon-sitemap"
                ></i>
                <i v-if="scope.row.type === 'major'" class="el-icon-book"></i>
                {{ scope.row.label }}
              </span>
            </template>
          </el-table-column>

          <!-- 类型列 -->
          <el-table-column
            label="类型"
            width="120"
            align="center"
            :formatter="formatType"
          ></el-table-column>

          <!-- 关联信息列 -->
          <el-table-column
            label="关联信息"
            min-width="150"
            align="center"
            :formatter="formatRelation"
          ></el-table-column>

          <!-- 操作列 -->
          <el-table-column label="操作" width="480" align="center">
            <template slot-scope="scope">
              <!-- 学校节点操作 -->
              <template v-if="scope.row.type === 'university'">
                <el-button
                  v-hasPermission="'majorGroup:add'"
                  size="mini"
                  type="primary"
                  @click="openAddGroupDialog(scope.row)"
                  icon="el-icon-plus"
                  >新增专业组</el-button
                >
              </template>

              <!-- 专业组节点操作（已添加生成试卷按钮） -->
              <template v-if="scope.row.type === 'majorGroup'">
                <el-button
                  v-hasPermission="'majorDetail:add'"
                  size="mini"
                  type="success"
                  @click="openAddDetailDialog(scope.row)"
                  icon="el-icon-plus"
                  >新增专业</el-button
                >
                <!-- 新增：生成试卷按钮 -->
                <el-button
                  v-hasPermission="'paper:generate'"
                  size="mini"
                  type="info"
                  @click="generatePaper(scope.row)"
                  icon="el-icon-document"
                  style="margin-left: 10px"
                  >生成试卷</el-button
                >
                <!-- 新增：生成书本按钮 -->
                <el-button
                  v-hasPermission="'book:generate'"
                  size="mini"
                  type="info"
                  @click="generateBook(scope.row)"
                  icon="el-icon-book"
                  style="margin-left: 10px"
                  >生成书本</el-button
                >
                <el-button
                  v-hasPermission="'majorGroup:update'"
                  size="mini"
                  @click="openEditGroupDialog(scope.row)"
                  icon="el-icon-edit"
                  >编辑</el-button
                >
                <el-button
                  v-hasPermission="'majorGroup:delete'"
                  size="mini"
                  type="text"
                  style="color: #f56c6c"
                  @click="handleDeleteGroup(scope.row)"
                  icon="el-icon-delete"
                  >删除</el-button
                >
              </template>

              <!-- 专业节点操作 -->
              <template v-if="scope.row.type === 'major'">
                <el-button
                  v-hasPermission="'majorDetail:update'"
                  size="mini"
                  @click="openEditDetailDialog(scope.row)"
                  icon="el-icon-edit"
                  >编辑</el-button
                >
                <el-button
                  v-hasPermission="'majorDetail:delete'"
                  size="mini"
                  type="text"
                  style="color: #f56c6c"
                  @click="handleDeleteDetail(scope.row)"
                  icon="el-icon-delete"
                  >删除</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页控件 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 15px; text-align: right"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑专业组弹窗 -->
    <el-dialog
      :title="isEditGroup ? '编辑专业组' : '新增专业组'"
      :visible.sync="groupDialogVisible"
      @close="resetGroupForm"
      width="80%"
    >
      <el-form
        ref="groupFormRef"
        :model="groupForm"
        label-width="120px"
        :rules="groupRules"
        size="mini"
      >
        <el-form-item label="学校名称" prop="univId">
          <el-autocomplete
            v-model="groupForm.univName"
            :fetch-suggestions="queryUniversity"
            placeholder="请输入学校名称搜索"
            @select="handleUniversitySelect"
            clearable
            style="width: 100%"
          ></el-autocomplete>
          <input type="hidden" v-model="groupForm.univId" />
        </el-form-item>
        <el-form-item label="专业组名称" prop="majorGroupName">
          <el-input
            v-model="groupForm.majorGroupName"
            placeholder="请输入专业组名称（如：计算机类专业组）"
          ></el-input>
        </el-form-item>
        <el-form-item label="录取规则" prop="admissionRules">
          <el-input
            type="textarea"
            v-model="groupForm.admissionRules"
            placeholder="请输入录取规则（如投档比例、加分政策等）"
            rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="考生类型" prop="examineeType">
          <el-select
            v-model="groupForm.examineeType"
            multiple
            placeholder="请选择考生类型"
            style="width: 100%"
          >
            <el-option label="应届普高" value="应届普高"></el-option>
            <el-option label="中职往届" value="中职往届"></el-option>
            <el-option label="社会考生" value="社会考生"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试形式" prop="examForm">
          <el-input
            v-model="groupForm.examForm"
            placeholder="如：机试、机试+面试、笔试+实操"
          ></el-input>
        </el-form-item>
        <el-form-item label="考试时长(分钟)" prop="examDuration">
          <el-input
            v-model.number="groupForm.examDuration"
            placeholder="请输入考试时长（单位：分钟）"
          ></el-input>
        </el-form-item>
        <!-- 原有考纲节点选择（多选） -->
        <el-form-item label="关联考纲节点" prop="examSyllabus">
          <el-cascader
            v-model="selectedSyllabusIds"
            :options="syllabusOptions"
            :props="cascaderProps"
            filterable
            clearable
            placeholder="请选择考纲对应的第三级节点（可多选、搜索）"
            style="width: 100%"
            @change="handleSyllabusChange"
          ></el-cascader>
          <div
            style="
              margin-top: 8px;
              color: #666;
              font-size: 12px;
              max-height: 80px;
              overflow-y: auto;
            "
          >
            已选节点：
            <span v-if="selectedSyllabusIds.length === 0">无</span>
            <span v-else>
              <div
                v-for="(id, idx) in selectedSyllabusIds"
                :key="idx"
                style="line-height: 1.5"
              >
                {{ getSyllabusFullPath(id) }}
              </div>
            </span>
          </div>
        </el-form-item>

        <!-- 新增试卷配置区域 -->
        <el-form-item label="试卷配置" label-width="120">
          <div class="exam-paper-container">
            <!-- 添加试卷按钮 -->
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-plus"
              @click="addExamPaperRow"
              style="margin-bottom: 10px"
              v-hasPermission="'majorGroupExamDetail:add'"
            >
              添加试卷题型
            </el-button>

            <!-- 试卷表格 -->
            <div class="paper-table" v-if="examPapers.length > 0">
              <!-- 表头 -->
              <div class="table-header">
                <div class="table-th" style="width: 40%">考试大纲节点</div>
                <div class="table-th" style="width: 15%">题量</div>
                <div class="table-th" style="width: 15%">每题分数</div>
                <div class="table-th" style="width: 15%">行总分</div>
                <div class="table-th" style="width: 15%">操作</div>
              </div>

              <!-- 数据行 -->
              <div class="table-body">
                <div
                  class="table-row"
                  v-for="(paper, index) in examPapers"
                  :key="index"
                >
                  <!-- 考纲节点选择（单选） -->
                  <div class="table-td" style="width: 40%">
                    <el-cascader
                      v-model="paper.testCenterId"
                      :options="syllabusOptions"
                      :props="singleCascaderProps"
                      filterable
                      clearable
                      placeholder="请选择单个节点"
                      style="width: 100%"
                      @change="handleSingleSyllabusChange($event, index)"
                      required
                    ></el-cascader>
                  </div>

                  <!-- 题量 -->
                  <div class="table-td" style="width: 15%">
                    <el-input
                      v-model.number="paper.questionCount"
                      type="number"
                      min="1"
                      placeholder="输入题量"
                      @input="calculateRowTotal(index)"
                      required
                    ></el-input>
                  </div>

                  <!-- 分数 -->
                  <div class="table-td" style="width: 15%">
                    <el-input
                      v-model.number="paper.score"
                      type="number"
                      min="0.5"
                      step="0.5"
                      placeholder="输入分数"
                      @input="calculateRowTotal(index)"
                      required
                    ></el-input>
                  </div>

                  <!-- 行总分 -->
                  <div class="table-td" style="width: 15%">
                    <span class="row-total">{{ paper.totalScore || 0 }}</span>
                  </div>

                  <!-- 操作 -->
                  <div class="table-td" style="width: 15%">
                    <el-button
                      type="text"
                      size="mini"
                      style="color: #f56c6c"
                      @click="deleteExamPaperRow(index)"
                      v-hasPermission="'majorGroupExamDetail:delete'"
                    >
                      删除
                    </el-button>
                  </div>
                </div>
              </div>

              <!-- 总分统计 -->
              <div class="table-footer">
                <div class="total-label">试卷总分：</div>
                <div class="total-value">
                  {{ totalExamScore.toFixed(2) }} 分
                </div>
              </div>
            </div>

            <!-- 无数据提示 -->
            <div class="no-data" v-else>
              暂无试卷题型，请点击"添加试卷题型"按钮
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="groupDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitGroupForm" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 新增/编辑专业详情弹窗 -->
    <el-dialog
      :title="isEditDetail ? '编辑专业' : '新增专业'"
      :visible.sync="detailDialogVisible"
      @close="resetDetailForm"
      width="60%"
    >
      <el-form
        ref="detailFormRef"
        :model="detailForm"
        label-width="150px"
        :rules="detailRules"
        size="mini"
      >
        <el-form-item label="所属专业组" prop="groupId">
          <el-input v-model="detailForm.groupName" disabled></el-input>
          <input type="hidden" v-model="detailForm.groupId" />
        </el-form-item>
        <el-form-item label="专业名称" prop="majorName">
          <el-autocomplete
            v-model="detailForm.majorName"
            :fetch-suggestions="queryMajor"
            placeholder="请输入专业名称搜索"
            @select="handleMajorSelect"
            clearable
            style="width: 100%"
          ></el-autocomplete>
          <input type="hidden" v-model="detailForm.majorId" />
        </el-form-item>
        <el-form-item label="班级类型" prop="classType">
          <el-select
            v-model="detailForm.classType"
            placeholder="请选择班级类型"
          >
            <el-option label="普通班" value="普通班"></el-option>
            <el-option label="订单班" value="订单班"></el-option>
            <el-option label="现代学徒制" value="现代学徒制"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合作企业" prop="classEnterprise">
          <el-input
            v-model="detailForm.classEnterprise"
            placeholder="请输入合作企业（如：华为技术有限公司）"
          ></el-input>
        </el-form-item>

        <el-divider>招生计划</el-divider>

        <el-form-item label="招生计划总数" prop="planNum">
          <el-input
            v-model.number="detailForm.planNum"
            placeholder="请输入招生计划总数"
          ></el-input>
        </el-form-item>
        <el-form-item label="应届普高计划数" prop="freshAcademicNum">
          <el-input
            v-model.number="detailForm.freshAcademicNum"
            placeholder="请输入应届普高毕业生计划数"
          ></el-input>
        </el-form-item>
        <el-form-item label="中职往届计划数" prop="secondaryTechGraduateNum">
          <el-input
            v-model.number="detailForm.secondaryTechGraduateNum"
            placeholder="请输入中职往届毕业生计划数"
          ></el-input>
        </el-form-item>

        <el-divider>录取信息</el-divider>

        <el-form-item label="报考总人数" prop="totalApplicants">
          <el-input
            v-model.number="detailForm.totalApplicants"
            placeholder="请输入报考总人数"
          ></el-input>
        </el-form-item>
        <el-form-item label="录取率(%)" prop="admissionRate">
          <el-input
            type="number"
            v-model.number="detailForm.admissionRate"
            :min="0"
            :max="100"
            step="0.01"
            placeholder="请输入录取率（0-100，支持2位小数）"
          ></el-input>
        </el-form-item>
        <el-form-item label="应届普高分数线" prop="freshAcademicScoreline">
          <el-input
            type="number"
            step="0.01"
            v-model.number="detailForm.freshAcademicScoreline"
            placeholder="请输入应届普高分数线（如：425.5）"
          ></el-input>
        </el-form-item>
        <el-form-item label="中职往届分数线" prop="secondaryTechScoreline">
          <el-input
            type="number"
            step="0.01"
            v-model.number="detailForm.secondaryTechScoreline"
            placeholder="请输入中职往届分数线"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="submitDetailForm"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MajorManagement",
  data() {
    return {
      loading: false,
      btnLoading: false,
      treeData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchForm: {
        univName: "",
        groupName: "",
        majorName: "",
      },
      groupDialogVisible: false,
      isEditGroup: false,
      syllabusOptions: [],
      selectedSyllabusIds: [],
      syllabusNodeMap: {},
      // 原有级联配置（多选）
      cascaderProps: {
        multiple: true,
        label: "label",
        value: "value",
        children: "children",
        expandTrigger: "click",
        emitPath: false,
        checkStrictly: false,
      },
      // 试卷配置级联配置（单选）
      singleCascaderProps: {
        multiple: false,
        label: "label",
        value: "value",
        children: "children",
        expandTrigger: "click",
        emitPath: false,
        checkStrictly: false,
      },
      // 试卷列表数据（适配后端MajorGroupExamDetailVO）
      examPapers: [],
      // 试卷总分
      totalExamScore: 0,
      // 存储原有试卷ID（用于删除）
      originalExamPaperIds: [],
      groupForm: {
        id: null,
        univId: null,
        univName: "",
        majorGroupName: "",
        admissionRules: "",
        examineeType: [],
        examForm: "",
        examDuration: null,
        examSyllabus: "",
      },
      groupRules: {
        univId: [{ required: true, message: "请选择学校", trigger: "blur" }],
        majorGroupName: [
          { required: true, message: "请输入专业组名称", trigger: "blur" },
          { max: 255, message: "名称长度不能超过255个字符", trigger: "blur" },
        ],
        examDuration: [
          {
            type: "number",
            min: 0,
            message: "请输入有效的考试时长",
            trigger: "blur",
          },
        ],
        examSyllabus: [
          { required: false, message: "请选择考纲节点", trigger: "change" },
        ],
      },
      detailDialogVisible: false,
      isEditDetail: false,
      detailForm: {
        id: null,
        groupId: null,
        groupName: "",
        majorId: null,
        majorName: "",
        classType: "",
        classEnterprise: "",
        planNum: 0,
        freshAcademicNum: 0,
        secondaryTechGraduateNum: 0,
        totalApplicants: 0,
        admissionRate: 0,
        freshAcademicScoreline: null,
        secondaryTechScoreline: null,
      },
      detailRules: {
        groupId: [
          { required: true, message: "请选择所属专业组", trigger: "blur" },
        ],
        majorName: [
          { required: true, message: "请输入专业名称", trigger: "blur" },
          { max: 100, message: "名称长度不能超过100个字符", trigger: "blur" },
        ],
        majorId: [{ required: true, message: "请选择专业", trigger: "blur" }],
        planNum: [
          {
            type: "number",
            min: 0,
            message: "计划数不能为负数",
            trigger: "blur",
          },
        ],
      },
      universities: [],
      majors: [],
      currentUnivId: null,
    };
  },
  created() {
    this.loadTreeData();
  },
  methods: {
    /** 加载树形数据（修改：移除批量查询试卷配置） */
    async loadTreeData() {
      this.loading = true;
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm,
        };
        const { data: res } = await this.$http.get("/majorGroup/treeData", {
          params,
        });

        if (res.code !== 200 || !Array.isArray(res.data)) {
          throw new Error("接口返回格式异常");
        }

        // 移除：批量查询所有专业组的试卷配置
        this.treeData = res.data;
        this.total = res.total || 0;
      } catch (err) {
        this.$message.error("加载数据失败：" + err.message);
        this.treeData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    /** 表格行样式分类 */
    tableRowClassName({ row }) {
      if (row.type === "university") return "university-row";
      if (row.type === "majorGroup") return "major-group-row";
      if (row.type === "major") return "major-row";
      return "";
    },

    /** 搜索按钮事件 */
    handleSearch() {
      this.pageNum = 1;
      this.loadTreeData();
    },

    /** 重置搜索条件 */
    resetSearch() {
      this.searchForm = { univName: "", groupName: "", majorName: "" };
      this.pageNum = 1;
      this.loadTreeData();
    },

    /** 格式化类型显示 */
    formatType(row) {
      switch (row.type) {
        case "university":
          return "学校";
        case "majorGroup":
          return "专业组";
        case "major":
          return "专业";
        default:
          return "";
      }
    },

    /** 格式化关联信息显示 */
    formatRelation(row) {
      if (row.type === "university")
        return `包含 ${row.children?.length || 0} 个专业组`;
      if (row.type === "majorGroup")
        return `包含 ${row.children?.length || 0} 个专业`;
      if (row.type === "major") return `所属专业组：${row.parentLabel || "-"}`;
      return "-";
    },

    /** 学校模糊查询 */
    queryUniversity(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      this.$http
        .get(`/majorGroup/fuzzyUniversity?keyword=${queryString}`)
        .then((res) => {
          if (res.data.code === 200) {
            this.universities = res.data.data.map((item) => ({
              value: item.univName,
              ...item,
            }));
            cb(this.universities);
          } else {
            this.$message.error(
              "搜索学校失败：" + (res.data.msg || "未知错误")
            );
            cb([]);
          }
        })
        .catch((err) => {
          this.$message.error("搜索异常：" + err.message);
          cb([]);
        });
    },

    /** 选择学校后赋值 */
    handleUniversitySelect(item) {
      this.groupForm.univId = item.univId;
      this.groupForm.univName = item.univName;
    },

    /** 打开新增专业组弹窗 */
    openAddGroupDialog(universityRow) {
      this.isEditGroup = false;
      this.groupForm = {
        id: null,
        univId: universityRow?.id || null,
        univName: universityRow?.label || "",
        majorGroupName: "",
        admissionRules: "",
        examineeType: [],
        examForm: "",
        examDuration: null,
        examSyllabus: "",
      };
      this.selectedSyllabusIds = [];
      this.syllabusNodeMap = {};
      // 初始化试卷列表为空
      this.examPapers = [];
      this.originalExamPaperIds = [];
      this.totalExamScore = 0;
      this.groupDialogVisible = true;
      this.loadAllSyllabusData();
    },

    /** 加载全量考纲树形数据 */
    async loadAllSyllabusData() {
      try {
        const { data: res } = await this.$http.get(
          "/testCenter/cascader-options"
        );
        if (res.code === 200 && Array.isArray(res.data)) {
          this.syllabusOptions = res.data;
          this.buildSyllabusNodeMap(res.data);
        } else {
          this.$message.error(
            "加载考纲数据失败：" + (res.data.msg || "数据格式异常")
          );
          this.syllabusOptions = [];
        }
      } catch (error) {
        this.$message.error("加载考纲数据异常：" + error.message);
        this.syllabusOptions = [];
      }
    },

    /** 构建节点映射（非递归） */
    buildSyllabusNodeMap(nodes) {
      const queue = [...nodes];
      this.syllabusNodeMap = {};

      while (queue.length > 0) {
        const node = queue.shift();
        this.syllabusNodeMap[node.value] = node;
        if (node.children && node.children.length > 0) {
          queue.push(...node.children);
        }
      }
    },

    /** 根据节点ID获取完整路径 */
    getSyllabusFullPath(nodeId) {
      if (!nodeId) return "-";
      const node = this.syllabusNodeMap[nodeId];
      if (!node) return `未知节点(${nodeId})`;

      if (node.parentValue) {
        const parentNode = this.syllabusNodeMap[node.parentValue];
        if (parentNode?.parentValue) {
          const grandParentNode = this.syllabusNodeMap[parentNode.parentValue];
          return `${grandParentNode.label} / ${parentNode.label} / ${node.label}`;
        }
        return `${parentNode?.label || ""} / ${node.label}`;
      }
      return node.label;
    },

    /** 原有级联选择器变化处理（多选） */
    handleSyllabusChange(value) {
      if (!value || value.length === 0) {
        this.selectedSyllabusIds = [];
        return;
      }
      const leafNodes = value.filter((id) => {
        const node = this.syllabusNodeMap[id];
        return node && (!node.children || node.children.length === 0);
      });
      this.selectedSyllabusIds = leafNodes;

      if (leafNodes.length !== value.length) {
        this.$message.warning("已自动过滤，只保留最末级节点");
      }
    },

    /** 打开编辑专业组弹窗（修改：保留编辑时查询试卷配置） */
    async openEditGroupDialog(row) {
      this.isEditGroup = true;
      this.groupForm = {
        id: row.id,
        univId: row.data.univId,
        univName: row.data.univName,
        majorGroupName: row.data.majorGroupName,
        admissionRules: row.data.admissionRules || "",
        examineeType: row.data.examineeType
          ? row.data.examineeType.split(",")
          : [],
        examForm: row.data.examForm || "",
        examDuration: row.data.examDuration || null,
        examSyllabus: row.data.examSyllabus || "",
      };
      this.groupDialogVisible = true;
      await this.loadAllSyllabusData();
      this.selectedSyllabusIds = this.groupForm.examSyllabus
        ? this.groupForm.examSyllabus.split(",").map(Number)
        : [];

      // 查询该专业组的试卷配置（仅编辑时调用）
      await this.loadExamPapersByGroupId(row.id);

      // 将查询到的试卷配置赋值给当前行，用于展开预览
      row.examPapers = this.examPapers;
    },

    /** 根据专业组ID查询试卷配置（核心接口调用，仅编辑时使用） */
    async loadExamPapersByGroupId(majorGroupId) {
      try {
        this.btnLoading = true;
        const { data: res } = await this.$http.get(
          `/majorGroupExamDetail/listByGroupId/${majorGroupId}`
        );
        if (res.code === 200 && Array.isArray(res.data)) {
          console.log("-------------------");
          // 存储原有试卷ID（用于后续删除）
          this.originalExamPaperIds = res.data.map((item) => item.id);
          // 转换为前端表格所需格式
          this.examPapers = res.data.map((paper) => ({
            id: paper.id, // 后端返回的明细ID
            testCenterId: paper.testCentersId || null, // 考纲节点ID
            testCenterPath: this.getSyllabusFullPath(paper.testCentersId), // 显示路径
            questionCount: paper.questionCount || 0, // 题量
            score: paper.score || 0, // 分数
            totalScore: (paper.questionCount || 0) * (paper.score || 0), // 行总分
          }));
          // 计算总分
          this.calculateTotalScore();
        } else {
          this.$message.error("加载试卷配置失败：" + (res.msg || "数据异常"));
          this.examPapers = [];
          this.originalExamPaperIds = [];
        }
      } catch (error) {
        this.$message.error("加载试卷配置异常：" + error.message);
        this.examPapers = [];
        this.originalExamPaperIds = [];
      } finally {
        this.btnLoading = false;
      }
    },

    /** 新增试卷行 */
    addExamPaperRow() {
      this.examPapers.push({
        id: null, // 新增行无ID
        testCenterId: null, // 考纲节点ID（test_centers_id）
        testCenterPath: "", // 考纲节点路径（显示用）
        questionCount: 1, // 题量（默认1）
        score: 1.0, // 分数（默认1.0）
        totalScore: 1.0, // 行总分（默认1.0）
      });
      // 计算总分
      this.calculateTotalScore();
    },

    /** 删除试卷行（调用后端接口） */
    async deleteExamPaperRow(index) {
      const paper = this.examPapers[index];

      // 如果是已保存的明细（有ID），需要调用删除接口
      if (paper.id) {
        try {
          await this.$http.delete(`/majorGroupExamDetail/delete/${paper.id}`);
          this.$message.success("删除成功");
          // 从原有ID列表中移除
          this.originalExamPaperIds = this.originalExamPaperIds.filter(
            (id) => id !== paper.id
          );
        } catch (error) {
          this.$message.error("删除失败：" + error.message);
          return;
        }
      }

      // 移除本地行数据
      this.examPapers.splice(index, 1);
      // 重新计算总分
      this.calculateTotalScore();
    },

    /** 试卷级联选择器变化处理（单选） */
    handleSingleSyllabusChange(val, index) {
      if (!val) {
        this.examPapers[index].testCenterId = null;
        this.examPapers[index].testCenterPath = "";
        return;
      }
      // 单选返回的是单个值，不是数组
      const nodeId = val;
      const node = this.syllabusNodeMap[nodeId];
      if (node && (!node.children || node.children.length === 0)) {
        this.examPapers[index].testCenterId = nodeId;
        this.examPapers[index].testCenterPath =
          this.getSyllabusFullPath(nodeId);
        // 重新计算当前行总分
        this.calculateRowTotal(index);
      } else {
        this.$message.warning("请选择最末级考纲节点");
        this.examPapers[index].testCenterId = null;
        this.examPapers[index].testCenterPath = "";
      }
    },

    /** 计算当前行总分 */
    calculateRowTotal(index) {
      const paper = this.examPapers[index];
      // 题量和分数默认0，避免NaN
      const questionCount = paper.questionCount || 0;
      const score = paper.score || 0;
      // 计算行总分（保留2位小数）
      paper.totalScore = Number((questionCount * score).toFixed(2));
      // 重新计算总总分
      this.calculateTotalScore();
    },

    /** 计算所有行总分 */
    calculateTotalScore() {
      this.totalExamScore = this.examPapers.reduce((sum, paper) => {
        return sum + (paper.totalScore || 0);
      }, 0);
      // 保留2位小数
      this.totalExamScore = Number(this.totalExamScore.toFixed(2));
    },

    /** 提交专业组表单（核心：先保存专业组，再批量保存试卷） */
    async submitGroupForm() {
      // 1. 表单验证
      try {
        await this.$refs.groupFormRef.validate();
      } catch (error) {
        return;
      }

      // 2. 试卷配置验证
      const invalidPaper = this.examPapers.find(
        (paper) => !paper.testCenterId || !paper.questionCount || !paper.score
      );
      if (invalidPaper) {
        this.$message.error("请完善所有试卷题型的考纲节点、题量和分数");
        return;
      }

      this.btnLoading = true;
      try {
        // 3. 保存专业组基本信息
        const formData = { ...this.groupForm };
        formData.examineeType = formData.examineeType.join(",");
        formData.examSyllabus = this.selectedSyllabusIds.join(",");

        let majorGroupId = formData.id;
        if (this.isEditGroup) {
          // 编辑专业组
          await this.$http.put("/majorGroup/update", formData);
        } else {
          // 新增专业组（获取返回的专业组ID）
          const { data: res } = await this.$http.post(
            "/majorGroup/add",
            formData
          );
          majorGroupId = res.data.id; // 假设新增接口返回专业组ID
        }

        // 4. 处理试卷配置：先删除已移除的原有明细
        const currentPaperIds = this.examPapers
          .filter((paper) => paper.id)
          .map((paper) => paper.id);
        const idsToDelete = this.originalExamPaperIds.filter(
          (id) => !currentPaperIds.includes(id)
        );
        if (idsToDelete.length > 0) {
          await this.$http.post("/majorGroupExamDetail/batchDelete", {
            ids: idsToDelete,
          });
        }

        // 5. 批量新增/更新试卷明细
        const examPaperVOList = this.examPapers.map((paper) => ({
          id: paper.id, // 有ID则为更新，无ID则为新增
          majorGroupId: majorGroupId, // 专业组ID（关键关联字段）
          testCentersId: paper.testCenterId, // 考纲节点ID
          questionCount: paper.questionCount, // 题量
          score: paper.score, // 分数
        }));

        // 区分新增和更新（后端批量接口可能只支持新增，更新需要单独处理）
        const addList = examPaperVOList.filter((item) => !item.id);
        const updateList = examPaperVOList.filter((item) => item.id);

        // 批量新增
        if (addList.length > 0) {
          await this.$http.post("/majorGroupExamDetail/batchAdd", {
            items: addList,
          });
        }

        // 批量更新（如果后端支持批量更新接口，否则循环调用update）
        for (const item of updateList) {
          await this.$http.put(`/majorGroupExamDetail/update/${item.id}`, item);
        }

        // 6. 提交成功后，更新树形表格中的试卷配置（用于展开预览）
        const groupNode = this.treeData.find(
          (node) => node.id === majorGroupId && node.type === "majorGroup"
        );
        if (groupNode) {
          groupNode.examPapers = this.examPapers;
        }

        // 7. 提交成功
        this.$message.success(
          this.isEditGroup
            ? "更新专业组及试卷配置成功"
            : "新增专业组及试卷配置成功"
        );
        this.groupDialogVisible = false;
        this.loadTreeData();
      } catch (err) {
        this.$message.error(
          "提交失败：" + (err.response?.data?.msg || err.message)
        );
      } finally {
        this.btnLoading = false;
      }
    },

    /** 删除专业组（需先删除关联的试卷明细） */
    async handleDeleteGroup(row) {
      this.$confirm(
        `确定删除【${row.label}】吗？删除后该专业组下的所有专业和试卷配置也将被删除。`,
        "警告",
        { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
      )
        .then(async () => {
          this.btnLoading = true;
          try {
            // 1. 先删除关联的试卷明细（需要查询当前专业组的试卷配置）
            const { data: res } = await this.$http.get(
              `/majorGroupExamDetail/listByGroupId/${row.id}`
            );
            if (
              res.code === 200 &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              const ids = res.data.map((item) => item.id);
              await this.$http.post("/majorGroupExamDetail/batchDelete", {
                ids,
              });
            }

            // 2. 再删除专业组
            await this.$http.delete(`/majorGroup/delete/${row.id}`);
            this.$message.success("删除成功");
            this.loadTreeData();
          } catch (err) {
            this.$message.error(
              "删除失败：" + (err.response?.data?.msg || err.message)
            );
          } finally {
            this.btnLoading = false;
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    /** 打开新增专业弹窗 */
    openAddDetailDialog(groupRow) {
      this.isEditDetail = false;
      this.detailForm = {
        id: null,
        groupId: groupRow.id,
        groupName: groupRow.label,
        majorId: null,
        majorName: "",
        classType: "",
        classEnterprise: "",
        planNum: 0,
        freshAcademicNum: 0,
        secondaryTechGraduateNum: 0,
        totalApplicants: 0,
        admissionRate: 0,
        freshAcademicScoreline: null,
        secondaryTechScoreline: null,
      };
      this.currentUnivId = groupRow.data.univId;
      this.detailDialogVisible = true;
    },

    /** 打开编辑专业弹窗 */
    openEditDetailDialog(row) {
      this.isEditDetail = true;
      this.detailForm = {
        id: row.id,
        groupId: row.parent.id,
        groupName: row.parent.label,
        majorId: row.data.majorId,
        majorName: row.data.majorName,
        classType: row.data.classType || "",
        classEnterprise: row.data.classEnterprise || "",
        planNum: row.data.planNum || 0,
        freshAcademicNum: row.data.freshAcademicNum || 0,
        secondaryTechGraduateNum: row.data.secondaryTechGraduateNum || 0,
        totalApplicants: row.data.totalApplicants || 0,
        admissionRate: row.data.admissionRate || 0,
        freshAcademicScoreline: row.data.freshAcademicScoreline || null,
        secondaryTechScoreline: row.data.secondaryTechScoreline || null,
      };
      console.log(row);
      this.currentUnivId = row.parent.univId;
      this.detailDialogVisible = true;
    },

    /** 专业模糊查询 */
    queryMajor(queryString, cb) {
      if (!this.currentUnivId) {
        this.$message.warning("请先选择所属专业组");
        cb([]);
        return;
      }
      if (!queryString) {
        cb([]);
        return;
      }
      this.$http
        .get(
          `/universityMajors/searchMajor?univId=${this.currentUnivId}&keyword=${queryString}`
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.majors = res.data.data.map((item) => ({
              value: `${item.majorName}${
                item.remark ? `（${item.remark}）` : ""
              }`,
              originalMajorName: item.majorName,
              ...item,
            }));
            cb(this.majors);
          } else {
            this.$message.error(
              "搜索专业失败：" + (res.data.msg || "未知错误")
            );
            cb([]);
          }
        })
        .catch((err) => {
          this.$message.error("搜索异常：" + err.message);
          cb([]);
        });
    },

    /** 选择专业后赋值 */
    handleMajorSelect(item) {
      this.detailForm.majorId = item.majorId;
      this.detailForm.majorName = item.originalMajorName;
    },

    /** 提交专业详情表单 */
    submitDetailForm() {
      this.$refs.detailFormRef.validate(async (valid) => {
        if (!valid) return;

        const submitData = { ...this.detailForm };
        this.btnLoading = true;
        try {
          let res;
          if (this.isEditDetail) {
            res = await this.$http.put("/majorDetail/update", submitData);
          } else {
            res = await this.$http.post("/majorDetail/add", submitData);
          }

          if (res.data.code === 200) {
            this.$message.success(this.isEditDetail ? "更新成功" : "新增成功");
            this.detailDialogVisible = false;
            this.loadTreeData();
          } else {
            this.$message.error(
              res.data.msg || (this.isEditDetail ? "更新失败" : "新增失败")
            );
          }
        } catch (err) {
          this.$message.error("操作异常：" + err.message);
        } finally {
          this.btnLoading = false;
        }
      });
    },

    /** 删除专业 */
    handleDeleteDetail(row) {
      this.$confirm(`确定删除专业【${row.label}】吗？`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const { data: res } = await this.$http.delete(
              `/majorDetail/delete/${row.id}`
            );
            if (res.data.code === 200) {
              this.$message.success("删除成功");
              this.loadTreeData();
            } else {
              this.$message.error(res.data.msg || "删除失败");
            }
          } catch (err) {
            this.$message.error("删除异常：" + err.message);
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    /** 重置专业组表单 */
    resetGroupForm() {
      if (this.$refs.groupFormRef) this.$refs.groupFormRef.resetFields();
      this.selectedSyllabusIds = [];
      this.syllabusNodeMap = {};
      this.examPapers = [];
      this.originalExamPaperIds = [];
      this.totalExamScore = 0;
    },

    /** 重置专业详情表单 */
    resetDetailForm() {
      if (this.$refs.detailFormRef) this.$refs.detailFormRef.resetFields();
    },

    /** 分页大小改变 */
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadTreeData();
    },

    /** 当前页改变 */
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadTreeData();
    },

    /** 导出数据 */
    exportExcel() {
      this.$http
        .post("/majorDetail/export", this.searchForm, { responseType: "blob" })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "专业组与专业数据.xlsx";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          this.$message.success("导出成功");
        })
        .catch((err) => {
          this.$message.error("导出异常：" + err.message);
        });
    },

    /** 格式化考纲节点文本 */
    formatSyllabusText(syllabusIds) {
      if (!syllabusIds) return "无";
      const idArr = syllabusIds.split(",").map(Number);
      return idArr.map((id) => this.getSyllabusFullPath(id)).join("、");
    },

    /** 预览时计算试卷总分 */
    calculatePreviewTotal(papers) {
      return papers
        .reduce((sum, paper) => {
          return sum + paper.questionCount * paper.score;
        }, 0)
        .toFixed(2);
    },

    /**
     * 新增：生成试卷（下载试卷+解析合并文档）
     * @param {Object} groupRow 专业组行数据（包含专业组ID）
     */
    async generatePaper(groupRow) {
      // 校验是否已配置试卷（可选：根据业务需求决定是否强制配置）
      if (!groupRow.examPapers || groupRow.examPapers.length === 0) {
        await this.$confirm(
          "该专业组尚未配置试卷题型，是否继续生成默认试卷？",
          "提示",
          {
            confirmButtonText: "继续",
            cancelButtonText: "取消",
            type: "info",
          }
        ).catch(() => {
          return; // 取消则终止操作
        });
      }

      this.btnLoading = true;
      try {
        // 调用后端合并下载接口（试卷+解析）
        const response = await this.$http({
          url: `/paper/generate/with-analysis`,
          method: "GET",
          params: { majorGroupId: groupRow.id }, // 传递专业组ID
          responseType: "blob", // 关键：指定响应类型为二进制流
          timeout: 30000, // 延长超时时间（生成文档可能耗时）
        });

        // 处理下载响应
        this.handleDownloadResponse(response, groupRow, '试卷+答案解析');
      } catch (err) {
        this.$message.error(
          "试卷生成失败：" + (err.response?.data?.msg || err.message)
        );
      } finally {
        this.btnLoading = false;
      }
    },

    /**
     * 新增：生成书本
     * @param {Object} groupRow 专业组行数据（包含专业组ID）
     */
    async generateBook(groupRow) {
      // 校验是否已配置试卷（可选：根据业务需求决定是否强制配置）
      if (!groupRow.examPapers || groupRow.examPapers.length === 0) {
        await this.$confirm(
          "该专业组尚未配置试卷题型，是否继续生成默认书本？",
          "提示",
          {
            confirmButtonText: "继续",
            cancelButtonText: "取消",
            type: "info",
          }
        ).catch(() => {
          return; // 取消则终止操作
        });
      }

      this.btnLoading = true;
      try {
        // 调用后端生成书本接口
        const response = await this.$http({
          url: `/book/generate`,
          method: "GET",
          params: { majorGroupId: groupRow.id }, // 传递专业组ID
          responseType: "blob", // 关键：指定响应类型为二进制流
          timeout: 30000, // 延长超时时间（生成文档可能耗时）
        });

        // 处理下载响应
        this.handleDownloadResponse(response, groupRow, '学习书本');
      } catch (err) {
        this.$message.error(
          "书本生成失败：" + (err.response?.data?.msg || err.message)
        );
      } finally {
        this.btnLoading = false;
      }
    },

    /**
     * 新增：处理文件下载响应（通用方法）
     * @param {Object} response 接口响应（blob类型）
     * @param {Object} groupRow 专业组行数据
     * @param {String} fileType 文件类型描述
     */
    handleDownloadResponse(response, groupRow, fileType) {
      // 从响应头获取文件名（如果后端返回）
      const contentDisposition = response.headers["content-disposition"];
      let fileName = `${groupRow.label}-${fileType}.docx`;

      if (contentDisposition) {
        try {
          // 解析后端返回的文件名（兼容不同编码）
          const decodeFileName = decodeURIComponent(
            contentDisposition.split("filename*=UTF-8''")[1]
          );
          if (decodeFileName) fileName = decodeFileName;
        } catch (e) {
          try {
            // 兼容旧版浏览器编码
            fileName = decodeURIComponent(
              contentDisposition.split("filename=")[1].replace(/"/g, "")
            );
          } catch (e2) {
            // 解析失败使用默认文件名
          }
        }
      }

      // 创建blob对象（Word文档MIME类型）
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // 下载文件（兼容所有浏览器）
      if (window.navigator.msSaveOrOpenBlob) {
        // IE浏览器兼容
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // 其他浏览器
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        // 释放URL对象
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }

      this.$message.success(`${fileType}生成成功，已开始下载！`);
    },
  },
};
</script>

<style scoped>
.box-card {
  margin: 10px;
}
.search-form {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
::v-deep .el-form-item {
  margin-right: 15px;
  margin-bottom: 10px;
}
.major-detail-expand,
.group-detail-expand {
  padding: 10px 0;
}
::v-deep .el-descriptions__item {
  padding: 10px;
}
::v-deep .el-divider--horizontal {
  margin: 10px 0;
}

/* 树形表格层级样式 */
::v-deep .tree-table .el-table__row .el-table__indent {
  padding-left: 10px !important;
}
::v-deep .tree-table .el-table__row[level="1"] .el-table__indent {
  width: 20px !important;
}
::v-deep .tree-table .el-table__row[level="2"] .el-table__indent {
  width: 60px !important;
}
::v-deep .tree-table .el-table__row[level="3"] .el-table__indent {
  width: 100px !important;
}

/* 节点名称样式 */
.node-indicator {
  display: inline-flex;
  align-items: center;
  padding: 2px 0;
}
.node-indicator i {
  margin-right: 8px;
  font-size: 14px;
}
.node-indicator.university i {
  color: #409eff;
}
.node-indicator.majorGroup i {
  color: #67c23a;
}
.node-indicator.major i {
  color: #e6a23c;
}
::v-deep .tree-table .el-table__expand-icon {
  margin-right: 5px;
}

/* 表格行颜色区分 */
::v-deep .university-row {
  background-color: #f0f9ff !important;
  border-left: 4px solid #409eff !important;
}
::v-deep .major-group-row {
  background-color: #f6ffed !important;
  border-left: 4px solid #67c23a !important;
}
::v-deep .major-row {
  background-color: #fff7e6 !important;
  border-left: 4px solid #e6a23c !important;
}

/* 操作按钮样式优化 */
::v-deep .el-button--mini {
  padding: 6px 12px;
}
::v-deep .major-row .el-button {
  background-color: #ffc0cb;
  border-color: #ffc0cb;
}

/* 试卷配置样式 */
.exam-paper-container {
  width: 100%;
}
.paper-table {
  width: 100%;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
}
.table-header {
  display: flex;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e6e6e6;
}
.table-th {
  padding: 10px;
  text-align: center;
  font-weight: 500;
  color: #333;
  border-right: 1px solid #e6e6e6;
  box-sizing: border-box;
}
.table-th:last-child {
  border-right: none;
}
.table-body {
  width: 100%;
}
.table-row {
  display: flex;
  border-bottom: 1px solid #e6e6e6;
}
.table-row:last-child {
  border-bottom: none;
}
.table-td {
  padding: 10px;
  border-right: 1px solid #e6e6e6;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-td:last-child {
  border-right: none;
}
.table-td ::v-deep .el-cascader,
.table-td ::v-deep .el-input {
  width: 90% !important;
}
.row-total {
  color: #409eff;
  font-weight: 500;
}
.table-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background-color: #fafafa;
  border-top: 1px solid #e6e6e6;
}
.total-label {
  margin-right: 10px;
  font-weight: 500;
  color: #333;
}
.total-value {
  color: #f56c6c;
  font-weight: 600;
  font-size: 14px;
}
.no-data {
  text-align: center;
  padding: 20px;
  color: #999;
}

/* 试卷预览样式 */
.exam-paper-preview {
  width: 100%;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
}
.preview-header {
  display: flex;
  background-color: #f5f7fa;
  padding: 8px 10px;
  border-bottom: 1px solid #e6e6e6;
}
.preview-header span {
  flex: 1;
  text-align: center;
  font-weight: 500;
  color: #333;
}
.preview-body {
  padding: 10px;
}
.preview-row {
  display: flex;
  padding: 5px 0;
  border-bottom: 1px dashed #e6e6e6;
}
.preview-row:last-child {
  border-bottom: none;
}
.preview-row span {
  flex: 1;
  text-align: center;
  color: #666;
}
.preview-total {
  text-align: right;
  padding: 8px 10px;
  background-color: #fafafa;
  border-top: 1px solid #e6e6e6;
  color: #f56c6c;
  font-weight: 600;
}
/* 无配置提示样式 */
.no-config {
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 14px;
}
</style>